import { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import Common from "./../common/common";
import { toast } from "react-toastify";
export default ({successCallBack}) => {
  let [isShowGoToExperinceLoader, setIsShowGoToExperinceLoader] =
    useState(false);
  const handleGoToExperinceClick = async () => {
      
    setIsShowGoToExperinceLoader(true);
    let path = await Common.getPathToOpen();
    if(path){
        window.open(path, "_blank") 
        successCallBack?.()
    }
    else{
        toast.error("Something broken please try again later.", { theme: "colored" });
    }

    setIsShowGoToExperinceLoader(false);
  };

  return (
    <a
      className="btn btn-custom md"
      style={{width:200}}
      variant="primary"
      onClick={handleGoToExperinceClick}
      // target={"_blank"}

    >
      {isShowGoToExperinceLoader ? (
        <Spinner size="sm" variant="grow" />
      ) : (
        " Go to Experience "
      )}
    </a>
  );
};
